import { render } from "./SospensioniForm.vue?vue&type=template&id=558a2f9c&scoped=true"
import script from "./SospensioniForm.vue?vue&type=script&lang=js"
export * from "./SospensioniForm.vue?vue&type=script&lang=js"

import "./SospensioniForm.vue?vue&type=style&index=0&id=558a2f9c&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558a2f9c"]])

export default __exports__